import { render, staticRenderFns } from "./Mizhi.vue?vue&type=template&id=6d12cbf2&"
import script from "./Mizhi.vue?vue&type=script&lang=js&"
export * from "./Mizhi.vue?vue&type=script&lang=js&"
import style0 from "./Mizhi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports